<template>
    <div ref="galleries" class="galleries"></div>
  </template>
  
  <script>
  //专馆
  import * as echarts from 'echarts';
  
  export default {
    name: "temperature",
    data() {
      return{
        myChart:{},
        option : {
  
        }
      }
    },
    methods:{
      init(){
        this.myChart= echarts.init(this.$refs.galleries);
        this.myChart.setOption(this.option);
      }
    },
    mounted() {
      //初始化
      // this.init();
    },
    created() {
  
      var now = new Date();
      var hours = now.getHours();
      
      var hourslist=[];
      for(let i=7;i>=0;i--){
        let temphours=hours-(i*3);
        if(temphours>=0){
          hourslist.push(temphours+":05")
        }else{
          temphours=24+temphours;
          hourslist.push(temphours+":05")
        }
      }
      
      let name=[];
      name[0]="温度";
      name[1]="湿度";
      let showtdata=[];
      showtdata[0]=[32,30,29,28,27,26,28,30];
      showtdata[1]=[55,56,56,58,60,60,59,58];
 



      let user_id = window.localStorage.getItem('user_id');
  
      const data = {
        'user_id': user_id
      };
  
      this.$api.zgu_broken_line(data).then(res=>
      {
  



        this.option = {
          title: {
            text: ''
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: name,
            show:false,
          },
          grid: {
            top:'8%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          // toolbox: {
          //   feature: {
          //     saveAsImage: {}
          //   }
          // },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: hourslist,
            axisLabel: {
              //x轴文字的配置
              show: true,
              interval: 1,//使x轴文字显示全
            }
          },
          yAxis: {
            type: 'value',
            show: true,    // 是否显示 y 轴
  
          },
          series: [
            {
              name: name[0],
              type: 'line', //折线图line;柱形图bar;饼图pie
              // smooth:true,
              stack: 'z',
              data: showtdata[0]
            },
            {
              name: name[1],
              type: 'line', //折线图line;柱形图bar;饼图pie
              // smooth:true,
              stack: 'y',
              data:  showtdata[1]
            }
  
          ]
        }
        this.myChart= echarts.init(this.$refs.galleries);
        this.myChart.setOption(this.option);
      })
  
  
    },
  
  }
  </script>
  
  <style scoped>
  .galleries {
    width: 100%;
    height: 100%;
  }
  </style>